import Grid from '@material-ui/core/Grid';
import { ThemeProvider } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import { Refresh } from '@material-ui/icons';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import React, { useEffect } from 'react';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import { allDevices, updateDevice } from 'redux/actions/devices.actions';
import AddBoxIcon from '@material-ui/icons/AddBox';
import Snackbar from '@material-ui/core/Snackbar';

import { useThunkDispatch, useTypedSelector } from 'hooks';

import { myTheme, Styles, getModalStyle, StyledTableCell, StyledTableRow } from '../Tools';
import { NewDevice } from './NewDevice';
import { Device } from '../../types/api/responses';
import { shouldReload } from '../../utils/state.handlers';
import Pagination from '@material-ui/lab/Pagination';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Alert } from '../Tools';
import { Loading } from '../Tools/Loading';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import ModalCustom from 'components/Tools/ModalCustom';

const SIZE = 10,
  INITPAGE = 1;

function SearchDetails() {
  const classes = Styles();

  const devices = useTypedSelector((z) => z.devices);
  const dispatch = useThunkDispatch();

  const [nameSearch, setNameSearch] = React.useState(
    devices.filter.ImeiSW ? devices.filter.ImeiSW : '',
  );

  const [openStatus, setOpenStatus] = React.useState(false);
  const [theStatus, setTheStatus] = React.useState(
    devices.filter.Status != null ? devices.filter.Status : '0',
  );

  //evento de cambio en nombre a buscar
  const handleChangeNameSearch = (event: React.ChangeEvent<{ value: unknown }>) => {
    setNameSearch(event.target.value as string);
  };

  //evento de busqueda segun nombre
  const handleSearch = () => {
    //alert(nameSearch + 'F');
    dispatch(
      allDevices(
        { page: INITPAGE, size: SIZE },
        {
          Status: devices.filter.Status,
          ImeiSW: nameSearch,
          NumberSW: devices.filter.NumberSW,
        },
      ),
    );
  };

  const handleResetSearch = () => {
    setTheStatus('0');
    setNameSearch('');
    dispatch(
      allDevices(
        { page: INITPAGE, size: SIZE },
        {
          Status: null,
          ImeiSW: null,
          NumberSW: null,
        },
      ),
    );
  };

  const handleOpenStatus = () => {
    setOpenStatus(true);
  };

  const handleClosedStatus = () => {
    setOpenStatus(false);
  };

  const handleChangeStatus = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string;
    setTheStatus(value);
    dispatch(
      allDevices(
        { page: INITPAGE, size: SIZE },
        {
          ImeiSW: devices.filter.ImeiSW,
          NumberSW: devices.filter.NumberSW,
          Status: value === '0' ? null : value,
        },
      ),
    );
  };

  return (
    <form className={classes.rootForm} noValidate autoComplete="off">
      {devices.isLoading ? (
        <div>
          <CircularProgress />
        </div>
      ) : (
        <div style={{ display: 'inline-flex', alignItems: 'center', marginRight: '10px' }}>
          <TextField
            id="outlined-read-only-input"
            label="IMEI"
            value={nameSearch}
            inputProps={{ maxLength: 16 }}
            onChange={handleChangeNameSearch}
            onKeyPress={(ev) => {
              if (ev.key === 'Enter') {
                ev.preventDefault();
                handleSearch();
              }
            }}
            variant="outlined"
            required
          />
          <FormControl style={{ marginRight: '10px' }}>
            <InputLabel id="select-filter-rol">Estado</InputLabel>
            <Select
              labelId="select-filter-rol"
              id="filter-controlled-open-select-rol"
              open={openStatus}
              onClose={handleClosedStatus}
              onOpen={handleOpenStatus}
              value={theStatus}
              onChange={handleChangeStatus}
            >
              <MenuItem value={'0'}>Todos</MenuItem>
              <MenuItem value={'Disabled'}>Inactivos</MenuItem>
              <MenuItem value={'Active'}>Activos</MenuItem>
            </Select>
          </FormControl>
          <Button
            variant="outlined"
            onClick={handleResetSearch}
            className={classes.submit}
            style={{ color: '#343c89', marginLeft: '15px' }}
            startIcon={<Refresh />}
          >
            Refrescar
          </Button>
        </div>
      )}
    </form>
  );
}

export function ListDevice() {
  const classes = Styles();
  const devices = useTypedSelector((u) => u.devices);
  const [page, setPage] = React.useState(1);
  const [minLoadingComplete, setMinLoadingComplete] = React.useState(false);

  // Add loading effect for minimum display time
  React.useEffect(() => {
    let timer: NodeJS.Timeout;
    
    if (devices.isLoading) {
      setMinLoadingComplete(false);
      timer = setTimeout(() => {
        setMinLoadingComplete(true);
      }, 3000); 
    } else if (!devices.isLoading) {
      const checkAndComplete = () => {
        if (!devices.isLoading) {
          setMinLoadingComplete(true);
        }
      };
      
      checkAndComplete();
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [devices.isLoading]);

  const [messageSnackbar, setMessageSnackbar] = React.useState<{
    open: boolean;
    message: string;
    severity: 'error' | 'warning' | 'info' | 'success';
  }>({
    open: false,
    message: '',
    severity: 'info',
  });

  const [messageSnack, setMessageSnack] = React.useState<string | null>(null);

  //modal
  const [openModal, setOpenModal] = React.useState({
    open: false,
    loading: false,
  });
  const [newDevice, setnewDevice] = React.useState(false);
  const [modalActive, setmodalActive] = React.useState(false);
  const [theDevice, setTheDevice] = React.useState({
    imei: '',
    manufacture: '',
    model: '',
    enable: false,
    number: '',
    assigned: null,
  });
  const dispatch = useThunkDispatch();

  const [fixInitComponent, setFixInitComponent] = React.useState(true);

  useEffect(() => {
    if (shouldReload(devices) || (fixInitComponent && devices.devices.devices.length == 0)) {
      setFixInitComponent(false);
      dispatch(
        allDevices(
          { size: SIZE, page: INITPAGE },
          {
            Status: null,
            ImeiSW: null,
            NumberSW: null,
          },
        ),
      );
    }
  }, [devices]);

  const handleChangePage = (event: React.ChangeEvent<unknown>, newPage: number) => {
    dispatch(allDevices({ page: newPage, size: SIZE }, devices.filter));
    setPage(newPage);
  };

  const handleOpenModal = () => {
    setMessageSnack(null);
    setOpenModal({
      open: true,
      loading: false,
    });
  };

  const handleCloseModal = (loading: boolean | null, flag: boolean) => {
    if (loading === null && !openModal.loading) {
      setOpenModal({
        open: false,
        loading: openModal.loading,
      });
    } else if (loading) {
      setOpenModal({
        open: openModal.open,
        loading: loading,
      });
    } else if (loading === false) {
      setOpenModal({
        open: false,
        loading: loading,
      });
    }
    if (flag) {
      setmodalActive(true);
    }
  };

  const handleChangeModal = ({ device, isNew }: { device: Device; isNew: boolean }) => {
    setnewDevice(isNew);
    setTheDevice({
      imei: device.imei,
      manufacture: device.manufacture ? device.manufacture : '',
      model: device.model ? device.model : '',
      enable: device.enable,
      number: device.number ? device.number : '',
      assigned: null,
    });
    handleOpenModal();
  };

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setMessageSnackbar({ ...messageSnackbar, open: false });
    setmodalActive(false);
  };

  const handleDesactive = ({ active, item }: { active: boolean; item: Device }) => {
    setMessageSnack(
      active
        ? 'El dispositivo se desbloqueó con éxito.'
        : 'El dispositivo se bloqueó con éxito.',
    );
    setmodalActive(false);
    setmodalActive(true);
    dispatch(
      updateDevice({
        imei: item.imei,
        manufacture: item.manufacture,
        model: item.model,
        enable: active,
        number: item.number,
        assigned: null,
      }),
    );
  };

  return (
    <ThemeProvider theme={myTheme}>
      <ModalCustom
        className={classes.paperModalNewUser}
        open={openModal.open}
        onClose={() => {
          handleCloseModal(null, false);
        }}
      >
        <NewDevice
          setMessageSnackbar={setMessageSnackbar}
          onSubmitFinish={() => {
            setOpenModal({ open: false, loading: false });
          }}
          device={theDevice}
          isNew={newDevice}
          handleClose={handleCloseModal}
        />
      </ModalCustom>

      <Snackbar open={messageSnackbar.open} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={messageSnackbar.severity}>
          {messageSnackbar.message}
        </Alert>
      </Snackbar>
      <Snackbar open={modalActive} autoHideDuration={15000} onClose={handleClose}>
        {devices.isLoading ? (
          <Alert onClose={handleClose} severity="info">
            <div>Editando Dispositivo...</div>
          </Alert>
        ) : (
          <div>
            {devices.error ? (
              <Alert onClose={handleClose} severity="error">
                <div>ocurrio un error {devices.error.message}</div>
              </Alert>
            ) : (
              <Alert onClose={handleClose} severity="success">
                <div> {messageSnack ? messageSnack : 'Se edito con exito el Dispositivo'}</div>
              </Alert>
            )}
          </div>
        )}
      </Snackbar>
      <div style={{
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        marginBottom: '24px',
        marginTop: '16px'
      }}>
        <PhoneAndroidIcon style={{ fontSize: '40px', color: '#343c89' }} />
        <div style={{ fontSize: '2rem', color: '#343c89', fontWeight: 700 }}>
          Dispositivos
        </div>
      </div>
      <div className={classes.divider}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Grid item xs={11} style={{ width: '100%' }}>
            <Paper 
              className={`${classes.paper} ${classes.flexWrap}`}
              elevation={3}
              style={{
                borderRadius: '12px',
                padding: '16px 24px',
                marginBottom: '16px'
              }}
            >
              <div className={classes.flexWrap}>
                <SearchDetails />
                <BottomNavigation
                  showLabels
                  onClick={() => {
                    handleChangeModal({
                      device: {
                        imei: '',
                        manufacture: '',
                        model: '',
                        enable: false,
                        number: '',
                        assigned: null,
                      },
                      isNew: true,
                    });
                  }}
                  style={{
                    backgroundColor: 'transparent',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <BottomNavigationAction
                    label="Agregar Registro"
                    icon={<AddBoxIcon />}
                    style={{ 
                      color: '#0e814b',
                      transition: 'all 0.3s ease'
                    }}
                  />
                </BottomNavigation>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={11} style={{ width: '100%', marginTop: '0.1em' }}>
            <Paper elevation={3} style={{ borderRadius: '12px', overflow: 'hidden' }}>
              <TableContainer
                style={{
                  maxHeight: '75vh',
                }}
              >
                <Table className={classes.table} stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell> IMEI Dispositivo</StyledTableCell>
                    <StyledTableCell align="center">Marca</StyledTableCell>
                    <StyledTableCell align="center">Modelo</StyledTableCell>
                    <StyledTableCell align="center">Telefono</StyledTableCell>
                    <StyledTableCell align="center">Asignado</StyledTableCell>
                    <StyledTableCell align="center">Estado</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {devices.devices.devices.map((item) => {
                    return (
                      <StyledTableRow key={item.imei}>
                        <StyledTableCell component="th" scope="row">
                          {item.imei}
                        </StyledTableCell>
                        <StyledTableCell align="center">{item.manufacture}</StyledTableCell>
                        <StyledTableCell align="center">{item.model}</StyledTableCell>
                        <StyledTableCell align="center">{item.number}</StyledTableCell>
                        <StyledTableCell align="center">
                          {item.assigned?.userName}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <div className={classes.flexRowCenter}>
                            <BottomNavigation
                              showLabels
                              onClick={() => {
                                handleChangeModal({ device: item, isNew: false });
                              }}
                              className={classes.buttons}
                              style={{ backgroundColor: 'transparent' }}
                            >
                              <BottomNavigationAction
                                label="Editar"
                                icon={<EditIcon />}
                                style={{ 
                                  color: '#343c89', 
                                  margin: '0px',
                                  cursor: 'pointer',
                                  borderRadius: '8px',
                                  transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = 'rgba(52, 60, 137, 0.1)';
                                  e.currentTarget.style.transform = 'scale(1.05)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent';
                                  e.currentTarget.style.transform = 'scale(1)';
                                }}
                              />
                            </BottomNavigation>
                            {(!minLoadingComplete || devices.isLoading) ? (
                              <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
                                <CircularProgress size={24} />
                              </div>
                            ) : (
                              <div>
                                {item.enable ? (
                                  <BottomNavigation showLabels className={classes.buttons} style={{ backgroundColor: 'transparent' }}>
                                    <BottomNavigationAction
                                      label="bloquear"
                                      onClick={() => {
                                        handleDesactive({ active: false, item: item });
                                      }}
                                      icon={<LockIcon />}
                                      style={{ 
                                        color: '#dc3545',
                                        cursor: 'pointer',
                                        borderRadius: '8px',
                                        transition: 'all 0.3s ease'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = 'rgba(220, 53, 69, 0.1)';
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                        e.currentTarget.style.transform = 'scale(1)';
                                      }}
                                    />
                                  </BottomNavigation>
                                ) : (
                                  <BottomNavigation showLabels className={classes.buttons} style={{ backgroundColor: 'transparent' }}>
                                    <BottomNavigationAction
                                      label="desbloquear"
                                      onClick={() => {
                                        handleDesactive({ active: true, item: item });
                                      }}
                                      icon={<LockOpenIcon />}
                                      style={{ 
                                        color: '#0e814b',
                                        cursor: 'pointer',
                                        borderRadius: '8px',
                                        transition: 'all 0.3s ease'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = 'rgba(14, 129, 75, 0.1)';
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                        e.currentTarget.style.transform = 'scale(1)';
                                      }}
                                    />
                                  </BottomNavigation>
                                )}
                              </div>
                            )}
                          </div>
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            </Paper>
          </Grid>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center',
            marginTop: '16px'
          }}>
            {(!minLoadingComplete || devices.isLoading) ? (
              <Loading 
                message="Cargando dispositivos..." 
                subMessage="Por favor espere mientras se cargan los dispositivos" 
              />
            ) : (
              <div style={{
                backgroundColor: 'white',
                padding: '12px',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                <Pagination
                  count={devices.devices.meta?.pages}
                  variant="outlined"
                  shape="rounded"
                  page={page}
                  onChange={handleChangePage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
